import { render, staticRenderFns } from "./popSetRemark.vue?vue&type=template&id=6d00653c"
import script from "./popSetRemark.vue?vue&type=script&lang=js"
export * from "./popSetRemark.vue?vue&type=script&lang=js"
import style0 from "./popSetRemark.vue?vue&type=style&index=0&id=6d00653c&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d00653c')) {
      api.createRecord('6d00653c', component.options)
    } else {
      api.reload('6d00653c', component.options)
    }
    module.hot.accept("./popSetRemark.vue?vue&type=template&id=6d00653c", function () {
      api.rerender('6d00653c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/saleOrder/components/popSetRemark/popSetRemark.vue"
export default component.exports